/**
 * Online Status Hook
 * Detects when the user goes offline/online
 */

import { useState, useEffect } from 'react';

import { debugLog, debugWarn } from '@/utils/logger';

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      debugLog('🌐 Back online');
      setIsOnline(true);
    };

    const handleOffline = () => {
      debugWarn('📡 Connection lost - offline mode');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
